

import useIntersectionObserver from './module/intersectionObserver'
import { useArrayFrom, useSvg } from './module/polyfill'
import * as _dropdown from './module/dropdown'
import Form from './module/form'
import {cookieA11Y, resizeFont, resetA11Y} from './module/a11y'
import { SlideShowHome, SlideShowTouch, slideShowArrow } from './module/slideshow'


(function () {

	useArrayFrom()
	useSvg()
	useIntersectionObserver()
	
	const body = document.body

	resizeFont(body)

	/**
	 * Slideshow Homepage
	 */
	if (document.querySelector('.slideshow')) {
		let slideshow = new SlideShowHome(document.querySelector('.slideshow-container'))
		slideshow.init()
	}

	const slideshowTouchInit = () => {

		let slideshow = document.querySelectorAll('.slideshow__touch')

		if (!slideshow) return 

		for (let i=0, lng=slideshow.length; i<lng; i++) {
			let slideshowItem = new SlideShowTouch(slideshow[i])
			slideshowItem.init()
		}

		window.onresize = function () {
			for (let i=0, lng=slideshow.length; i<lng; i++) {
				let slideshowItem = new SlideShowTouch(slideshow[i])
				slideshowItem.init()
			}
		}
	}
	slideshowTouchInit()

    /**
     * Lazyloading
     */
    const lazyLoad = () => {

		let lazyImages = Array.from(document.querySelectorAll('img.lazy'))
        
        let lazyImageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {

                if (!entry.isIntersecting)
                    return

                let lazyImage = entry.target
                lazyImage.src = lazyImage.getAttribute('data-src')
				lazyImage.removeAttribute('data-src')
				

                if (lazyImage.getAttribute('data-srcset')) {
                	lazyImage.srcset = lazyImage.getAttribute('data-srcset')
					lazyImage.removeAttribute('data-srcset')
                }

                if (lazyImage.getAttribute('data-sizes')) {
                    lazyImage.sizes = lazyImage.getAttribute('data-sizes')
					lazyImage.removeAttribute('data-sizes')
				}
                
                lazyImage.classList.remove('lazy')
                lazyImageObserver.unobserve(lazyImage)
            })
        })

		lazyImages.forEach((lazyImage) => lazyImageObserver.observe(lazyImage))
    }

    if ('IntersectionObserver' in window)
		lazyLoad()

	/**
	 * Toggle Menu
	 */
	const toggleMenu = () => {
		document.querySelector('.navbar').classList.toggle('trigger')
		body.classList.toggle('trigger')
	}

	/**
	 * Toggle Submenu
	 * @param el <Element>
	 */
	const toggleSubmenu = el => {
		
		let container = document.querySelector('.menu'),
			current   = container.querySelector('.trigger')

		if (current && current !== el)
			current.classList.remove('trigger')

		el.classList.toggle('trigger')
		
		if ((current === el || !current) && window.matchMedia('(min-width: 768px)').matches)
			body.classList.toggle('trigger')
	}

	/**
	 * Close Submenu
	 */
	const closeSubmenu = () => {
		
		let container = document.querySelector('.menu'),
			current   = container.querySelector('.trigger')

		if (current)
			current.classList.remove('trigger')

		if (body.classList.contains('trigger') && window.matchMedia('(min-width: 768px)').matches)
			body.classList.remove('trigger')
	}

	const closeParent = (el) => {
		document.querySelector('.menu__list__item.has-submenu.trigger').classList.remove('trigger')
		document.body.classList.remove('trigger')
	}

	/**
	 * Trigger navbar on scroll
	 */
	const triggerNavbar = () => {

		let navbar = document.querySelector('.header'),
			main   = document.querySelector('main')

		if (window.pageYOffset > 0 && !navbar.classList.contains('trigger')) {
			navbar.classList.add('trigger')
			return main.classList.add('trigger')
		}

		if (window.pageYOffset === 0 && navbar.classList.contains('trigger')) {
			navbar.classList.remove('trigger')
			return main.classList.remove('trigger')
		}
	}

	/**
	 * Map svg
	 */
	const handleMapSvg = () => {
		let map = document.querySelector('.map__svg')
		map.addEventListener('mouseover', (e) => {

			let el 		 = e.target,
				baseline = document.querySelector('.map__svg__title')

			if (!el.classList.contains('map__svg__item')) 
				return baseline.innerHTML = 'Explorez'

			document.querySelector('.map__svg__title').innerHTML = el.getAttribute('data-title')
		})
		// map.addEventListener('mouseleave', () => {
		// 	// baseline.innerHTML = 'Explorez'
		// })

		map.addEventListener('click', (e) => {

			let el = e.target

			if (!el.classList.contains('map__svg__item') || !el.hasAttribute('data-url')) return 

			window.location.replace(el.getAttribute('data-url'))
		})
	}

	if (document.querySelector('.map__svg'))
		handleMapSvg()

	const tabTrigger = (el) => {
		let nodes = Array.from(document.querySelectorAll('.tab-trigger')),
			index = nodes.indexOf(el),
			tab   = document.querySelectorAll('.tab__content')

		if (tab[index].classList.contains('trigger')) return 

		document.querySelector('.tab__content.trigger').classList.remove('trigger')
		tab[index].classList.add('trigger')
	}

	/**
	 * Instance Contact Form
	 */
	if (document.querySelector('.form')) {
		let form = new Form(document.querySelector('.form'))
		form.registerEvents()
	}

	/**
	 * A11Y Modal
	 */
	const openAccessibilityModal = (el) => {
		el.classList.toggle('trigger')

		if (el.classList.contains('trigger'))
			document.querySelector('.a11y__box__close').focus()
	}

	const closeAccessibilityModal = () => {

		let a11y = document.querySelector('.a11y')
		
		a11y.classList.remove('trigger')
		a11y.focus()
	}

	/**
	 * Display Town list or map
	 */
	const choiceTab = (el) => {
		console.log('oinopn')
		el.classList.toggle('trigger')
		document.querySelector('.town__list').classList.toggle('trigger')
		document.querySelector('.map__svg__container').classList.toggle('trigger')
	}
	
	/**
	 * Global events
	 */
	body.addEventListener('click', e => {
		let el = e.target

		if (document.querySelector('.dropdown-filter-trigger.trigger'))
			_dropdown.blurDropdown(el)

		if (el.classList.contains('menu-trigger'))
			return toggleMenu()

		if (el.classList.contains('has-submenu'))
			return toggleSubmenu(el)

		if (el.classList.contains('menu__list__item') && !el.classList.contains('has-submenu'))
			return closeSubmenu()

		if (el.classList.contains('submenu__close'))
			return closeParent(el)

		if (el.classList.contains('dropdown-filter-trigger'))
			_dropdown.triggerDropdown(el)

		if (el.classList.contains('dropdown-filter-opt-item'))
			_dropdown.selectOpt(el)

		if (el.classList.contains('accordion-trigger'))
			return el.classList.toggle('trigger')

		if (el.classList.contains('single__post__share__trigger'))
			return el.classList.toggle('trigger')

		if (el.classList.contains('tab-trigger'))
			return tabTrigger(el)

		if (el.classList.contains('slideshow__history__controller'))
			return slideShowArrow(el)

		if (el.classList.contains('open-searchform'))
			return document.querySelector('.searchform').classList.toggle('trigger')

		if (el.classList.contains('close-searchform'))
			return document.querySelector('.searchform').classList.remove('trigger')

		if (el.classList.contains('a11y'))
			return openAccessibilityModal(el)

		if (el.classList.contains('a11y__box__close'))
			return closeAccessibilityModal()

		if (el.classList.contains('choice-tab'))
			return choiceTab(el)

		if (el.hasAttribute('data-cookie'))
			return cookieA11Y(el, body)

		if (el.classList.contains('a11y-custom-reset'))
			return resetA11Y(body)

		if (el.classList.contains('a11y-custom-print'))
			return window.print()
	})

	window.addEventListener('scroll', () => triggerNavbar())
	triggerNavbar()

    
})()
